import { useForm } from "react-hook-form";
import { Input } from "../../../EditOnboarding/components/Input";
import { Dropdown } from "../../../EditOnboarding/components/Select";
import { IOptionProps, IOptionsProps } from "../../../../@types/reactSelect/IOption";
import Constants from "../../../../constants/Index";
import axios from "../../../../services/axios";
import { useEffect, useState } from "react";
import { useTaskCreation } from "../../../../hooks/useTaskCreation";
import { FooterEditOnboarding } from "../../../EditOnboarding/Footer";
import { useFilter } from "../../../../hooks/useFilter";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Modal } from "../../../Modal/Default/Index";
import { ButtonOnlyTitle } from "../../../Buttons/ButtonOnlyTitle/Index";
import "./styles.css"



export function WeightAnimals() {
    const [sumProportion, setSumProportion] = useState(0);

    const schema = yup.object().shape({
        farm: yup.object().required("Selecione a fazenda"),
        months: yup.array().min(1, "Selecione pelo menos um mês").required("Selecione pelo menos um mês"),
        proportion: yup.array()
            .test(
                "sum-100",
                `As proporções devem somar 100%`,
                (proportion = []) => {
                    const sum = proportion.reduce((acc: number, curr: any) => acc + (Number(curr) || 0), 0);
                    setSumProportion(Math.ceil(sum))
                    return Math.ceil(sum) === 100;
                }
            ),
        parameter: yup.object().shape({
            BIRTH_WEIGHT: yup.object().shape({
                MALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
                FEMALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
            }),
            WEANING_WEIGHT_210_DAYS: yup.object().shape({
                MALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
                FEMALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
            }),
            AVERAGE_DAILY_GAIN_REARING_WET: yup.object().shape({
                MALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
                FEMALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
            }),
            AVERAGE_DAILY_GAIN_REARING_DRY: yup.object().shape({
                MALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
                FEMALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
            }),
            ADULT_WEIGHT: yup.object().shape({
                MALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
                FEMALE: yup.number().min(0, "Não pode ser valor negativo").required("Informe"),
            }),
        })
    });

    const {
        handleSubmit,
        watch,
        setValue,
        control,
        formState: { errors },
        reset
    } = useForm({
        resolver: yupResolver(schema),
    });
    const { setSystemManager } = useFilter();

    const { allFarms } = useTaskCreation()
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Ocorreu um erro na ação");
    const [farmOptions, setFarmOptions] = useState<IOptionsProps>();
    const [submiting, setSubmiting] = useState(false);
    const [monthlyEvolution] = useState(new Map<number, any>());
    const [parameters] = useState(new Map<string, any>());
    const months = watch("months");
    const farmSelected = watch("farm");

    useEffect(() => {
        setFarmOptions(allFarms?.map(farm => ({
            label: farm.name,
            value: farm.id,
            info: farm
        })))
    }, [allFarms]);

    useEffect(() => {
        Constants.MONTHS_FULL_NAME_OPTIONS.forEach((month) => {
            if (months && months.some((m: IOptionProps) => Number(m?.value) === month?.value)) {
                if (watch(`proportion[${month?.value}]`) === undefined) {
                    setValue(`proportion[${month?.value}]`, 0);
                }
            } else {
                setValue(`proportion[${month?.value}]`, 0);
            }
        })
    }, [months]);

    useEffect(() => {
        setValue("months", []);

        if (submiting) return;

        if (farmSelected) {
            axios
                .get(`/monthly-evolution/${farmSelected?.value}`)
                .then((response) => {
                    monthlyEvolution.clear();

                    response.data.map((item: any) => monthlyEvolution.set(item.month, item.id));

                    const monthsData = response.data.sort((a: any, b: any) => a.id - b.id).map((item: any) => {
                        return Constants.MONTHS_FULL_NAME_OPTIONS.find(month => {
                            if (item.rate_months_value == 0) return
                            return month?.value === item?.month
                        });
                    });

                    const reorderedMonthsData = (() => {
                        const lastUndefinedIndex = monthsData.findIndex((month: any) => month === undefined);
                        if (lastUndefinedIndex === -1) return monthsData;
                        const monthsAfterLastUndefined = monthsData.slice(lastUndefinedIndex + 1);
                        const monthsBeforeLastUndefined = monthsData.slice(0, lastUndefinedIndex + 1);
                        return [...monthsAfterLastUndefined, ...monthsBeforeLastUndefined];
                    })();

                    setValue("months", reorderedMonthsData.filter((month: any) => month !== undefined));

                    response.data.map((item: any) => {
                        setValue(`proportion[${item.month}]`, item.rate_months_value)
                    });
                })

            axios
                .get(`/parameter-evolution/${farmSelected?.value}`)
                .then((response) => {
                    parameters.clear();

                    response.data.map((item: any) => parameters.set(`${item.parameter}.${item.type}`, item.id))

                    const parameter = response.data.reduce((acc: any, curr: any) => {
                        if (!acc[curr.parameter]) {
                            acc[curr.parameter] = {};
                        }
                        acc[curr.parameter][curr.type] = curr?.value;
                        return acc;
                    }, {});

                    Object.keys(parameter).forEach((paramKey) => {
                        Object.keys(parameter[paramKey]).forEach((typeKey) => {
                            const fieldName = `parameter.${paramKey}.${typeKey}`;
                            const fieldValue = parameter[paramKey][typeKey];

                            setValue(fieldName, fieldValue);
                        });
                    });
                })

        }
    }, [farmSelected, submiting]);

    function saveMonthyEvolution(response: any) {
        if (submiting) {
            return;
        }

        setSubmiting(true);

        const mapMounths = new Map<number, any>()

        response.months.map((month: IOptionProps, index: number) => {
            mapMounths.set(Number(month.value), {
                id: monthlyEvolution.get(Number(month.value)) || null,
                month: Number(month.value),
                name: month.label,
                days_per_month: month.info,
                rate_months_value: response.proportion[Number(month.value)] || 0,
                initial_month: index == 0,
                farm_id: Number(farmSelected.value)
            })
        })

        const allMounths = Constants.MONTHS_FULL_NAME_OPTIONS.map(month => mapMounths.has(month.value) ? mapMounths.get(month.value) : {
            id: monthlyEvolution.get(month.value) || null,
            month: Number(month.value),
            name: month.label,
            days_per_month: month.info,
            rate_months_value: 0,
            initial_month: false,
            farm_id: Number(farmSelected.value)
        })

        axios
            .post("/monthly-evolution", allMounths)
            .then(() => {
                const parameterEvolution = [{
                    id: parameters.get(`BIRTH_WEIGHT.MALE`) || null,
                    parameter: "BIRTH_WEIGHT",
                    type: "MALE",
                    value: response.parameter.BIRTH_WEIGHT.MALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`BIRTH_WEIGHT.FEMALE`) || null,
                    parameter: "BIRTH_WEIGHT",
                    type: "FEMALE",
                    value: response.parameter.BIRTH_WEIGHT.FEMALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`WEANING_WEIGHT_210_DAYS.MALE`) || null,
                    parameter: "WEANING_WEIGHT_210_DAYS",
                    type: "MALE",
                    value: response.parameter.WEANING_WEIGHT_210_DAYS.MALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`WEANING_WEIGHT_210_DAYS.FEMALE`) || null,
                    parameter: "WEANING_WEIGHT_210_DAYS",
                    type: "FEMALE",
                    value: response.parameter.WEANING_WEIGHT_210_DAYS.FEMALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`AVERAGE_DAILY_GAIN_REARING_WET.MALE`) || null,
                    parameter: "AVERAGE_DAILY_GAIN_REARING_WET",
                    type: "MALE",
                    value: response.parameter.AVERAGE_DAILY_GAIN_REARING_WET.MALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`AVERAGE_DAILY_GAIN_REARING_WET.FEMALE`) || null,
                    parameter: "AVERAGE_DAILY_GAIN_REARING_WET",
                    type: "FEMALE",
                    value: response.parameter.AVERAGE_DAILY_GAIN_REARING_WET.FEMALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`AVERAGE_DAILY_GAIN_REARING_DRY.MALE`) || null,
                    parameter: "AVERAGE_DAILY_GAIN_REARING_DRY",
                    type: "MALE",
                    value: response.parameter.AVERAGE_DAILY_GAIN_REARING_DRY.MALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`AVERAGE_DAILY_GAIN_REARING_DRY.FEMALE`) || null,
                    parameter: "AVERAGE_DAILY_GAIN_REARING_DRY",
                    type: "FEMALE",
                    value: response.parameter.AVERAGE_DAILY_GAIN_REARING_DRY.FEMALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`ADULT_WEIGHT.MALE`) || null,
                    parameter: "ADULT_WEIGHT",
                    type: "MALE",
                    value: response.parameter.ADULT_WEIGHT.MALE,
                    farm_id: farmSelected.value
                }, {
                    id: parameters.get(`ADULT_WEIGHT.FEMALE`) || null,
                    parameter: "ADULT_WEIGHT",
                    type: "FEMALE",
                    value: response.parameter.ADULT_WEIGHT.FEMALE,
                    farm_id: farmSelected.value
                }]

                axios.post("/parameter-evolution", parameterEvolution)
                    .then(() => {
                        axios.post(`/evolutions/${farmSelected.value}`)
                            .then(() => {
                                setSystemManager(null);
                                reset();
                            })
                            .catch(error => {
                                setErrorModal(true)
                                setErrorMessage(error.response?.data?.message || "Ocorreu um erro ao salvar os parâmetros de evolução");
                                console.error("Error saving parameter evolution:", error);
                            })
                    })
                    .catch((error) => {
                        setErrorModal(true)
                        setErrorMessage(error.response?.data?.message || "Ocorreu um erro ao salvar os parâmetros de evolução");
                        console.error("Error saving parameter evolution:", error);
                    });
            })
            .catch((error) => {
                setErrorModal(true)
                setErrorMessage(error.response?.data?.message || "Ocorreu um erro ao salvar a evolução mensal");
                console.error("Error saving monthly evolution:", error);
            })
            .finally(() => {
                setSubmiting(false);
            });
    }

    return (
        <>
            <Modal
                visible={errorModal}
                contentStyle={{
                    padding: "60px",
                    width: "433px",
                    height: "auto",
                    borderRadius: 25,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 30
                }}
            >
                <span>
                    {errorMessage || "Ocorreu um erro na ação"}
                </span>
                <footer className="buttons-container">
                    <ButtonOnlyTitle
                        title="Voltar"
                        theme="info"
                        onClick={() => {
                            setErrorModal(false)
                        }}
                    />
                </footer>
            </Modal>

            <form onSubmit={handleSubmit((data) => console.log(data))}>
                <main style={{ overflow: "auto", height: "calc(100vh - 420px)" }}>
                    <div style={{ width: 600 }}>
                        <div className={'body__formEditOnboarding'} style={{ flexDirection: "column", overflow: "auto" }}>
                            <div>
                                <Dropdown
                                    control={control}
                                    name={"farm"}
                                    options={farmOptions}
                                    placeholderText="Selecione a fazenda"
                                    label="Fazenda"
                                    closeMenuOnSelect
                                    noOptionsMessage={() => "Nenhuma fazenda encontrada"}
                                />

                                <Dropdown
                                    control={control}
                                    name={"months"}
                                    label="Estação de Nascimento"
                                    options={
                                        (() => {
                                            if (months && months.length == 12)
                                                return []

                                            if (!months || months.length === 0) {
                                                return Constants.MONTHS_FULL_NAME_OPTIONS;
                                            }

                                            const lastMonthValue = Number(months[months.length - 1].value);

                                            // Se o último for o último do array, permite selecionar o primeiro
                                            if (lastMonthValue === Constants.MONTHS_FULL_NAME_OPTIONS[Constants.MONTHS_FULL_NAME_OPTIONS.length - 1]?.value) {
                                                return Constants.MONTHS_FULL_NAME_OPTIONS.filter(
                                                    (option) =>
                                                        option?.value === Constants.MONTHS_FULL_NAME_OPTIONS[0]?.value
                                                );
                                            }

                                            return Constants.MONTHS_FULL_NAME_OPTIONS.filter(
                                                (option) =>
                                                    option?.value === lastMonthValue + 1 &&
                                                    !months.some((m: IOptionProps) => Number(m?.value) === option?.value)
                                            );
                                        })()
                                    }
                                    placeholderText="Selecione os mêses"
                                    isMulti
                                    noOptionsMessage={() => "Nenhum mês disponível"}
                                />

                                {months && months.map((month: IOptionProps, index: number) => {
                                    if (!month) return
                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                display: months && months.some((m: IOptionProps) => Number(m?.value) == Number(month?.value)) ? "flex" : "none",
                                            }}
                                        >
                                            <Input
                                                control={control}
                                                name={`proportion[${month.value}]`}
                                                theme={"normal"}
                                                label={`Proporção ${month.label}`}
                                                defaultValue={0}
                                                type="number"
                                                errorText={(errors?.proportion as any)?.message as any}
                                                hideError
                                                min={0}
                                                max={100}
                                                onChange={(e: any) => {
                                                    const value = e.target.value;

                                                    if (value < 0) {
                                                        setValue(`proportion[${month.value}]`, 0);
                                                    } else if (value > 100) {
                                                        setValue(`proportion[${month.value}]`, 100);
                                                    } else {
                                                        setValue(`proportion[${month.value}]`, value);
                                                    }
                                                }}
                                            />
                                        </div>
                                    )
                                })}

                                <br />
                                <small className="textInput--small-error animation__fadeIn">
                                    {months && months.length > 0 && (errors?.proportion as any)?.message && sumProportion != 100 ? `As proporções somam ${sumProportion}%` : ""}
                                </small>
                            </div>


                            <div>
                                <h2>Parâmetros</h2>

                                <div className="weightAnimalsContainers">
                                    <h5 className="weightAnimalsLabel">Peso ao nascimento</h5>
                                    <div className="weightAnimalsInputs" style={{ justifyContent: "space-between" }}>
                                        <div>
                                            <Input style={{ width: 240 }} type="number" control={control} name={`parameter.BIRTH_WEIGHT.MALE`} theme={"normal"} label="Macho" errorText={(errors?.parameter as any)?.BIRTH_WEIGHT?.MALE?.message as any} hideError min={0} />
                                        </div>
                                        <div>
                                            <Input style={{ width: 240 }} type="number" control={control} name={`parameter.BIRTH_WEIGHT.FEMALE`} theme={"normal"} label="Femea" errorText={(errors?.parameter as any)?.BIRTH_WEIGHT?.FEMALE?.message as any} hideError min={0} />
                                        </div>
                                    </div>
                                </div>

                                <div className="weightAnimalsContainers">
                                    <h5 className="weightAnimalsLabel">Peso a desmama (210 dias)</h5>
                                    <div className="weightAnimalsInputs" style={{ justifyContent: "space-between" }}>
                                        <div>
                                            <Input style={{ width: 240 }} type="number" control={control} name={`parameter.WEANING_WEIGHT_210_DAYS.MALE`} theme={"normal"} label="Macho" errorText={(errors?.parameter as any)?.WEANING_WEIGHT_210_DAYS?.MALE?.message as any} hideError min={0} />
                                        </div>
                                        <div>
                                            <Input style={{ width: 240 }} type="number" control={control} name={`parameter.WEANING_WEIGHT_210_DAYS.FEMALE`} theme={"normal"} label="Femea" errorText={(errors?.parameter as any)?.WEANING_WEIGHT_210_DAYS?.FEMALE?.message as any} hideError min={0} />
                                        </div>
                                    </div>
                                </div>

                                <div className="weightAnimalsContainers">
                                    <h5 className="weightAnimalsLabel"> GMD recria</h5>

                                    <div style={{
                                        borderLeft: "3px solid #62b8ae", paddingLeft: 10, marginBottom: 10
                                    }}>
                                        <span>Aguas</span>
                                        <div className="weightAnimalsInputs" style={{ justifyContent: "space-between" }}>
                                            <div>
                                                <Input type="number" control={control} name={`parameter.AVERAGE_DAILY_GAIN_REARING_WET.MALE`} theme={"normal"} label="Macho" errorText={(errors?.parameter as any)?.AVERAGE_DAILY_GAIN_REARING_WET?.MALE?.message as any} hideError min={0} />
                                            </div>
                                            <div>
                                                <Input style={{ width: 240 }} type="number" control={control} name={`parameter.AVERAGE_DAILY_GAIN_REARING_WET.FEMALE`} theme={"normal"} label="Femea" errorText={(errors?.parameter as any)?.AVERAGE_DAILY_GAIN_REARING_WET?.FEMALE?.message as any} hideError min={0} />
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{
                                        borderLeft: "3px solid #d9b43c", paddingLeft: 10, marginBottom: 10
                                    }}>
                                        <span>Seca</span>
                                        <div className="weightAnimalsInputs" style={{ justifyContent: "space-between" }}>
                                            <div>
                                                <Input type="number" control={control} name={`parameter.AVERAGE_DAILY_GAIN_REARING_DRY.MALE`} theme={"normal"} label="Macho" errorText={(errors?.parameter as any)?.AVERAGE_DAILY_GAIN_REARING_DRY?.MALE?.message as any} hideError min={0} />
                                            </div>
                                            <div>
                                                <Input style={{ width: 240 }} type="number" control={control} name={`parameter.AVERAGE_DAILY_GAIN_REARING_DRY.FEMALE`} theme={"normal"} label="Femea" errorText={(errors?.parameter as any)?.AVERAGE_DAILY_GAIN_REARING_DRY?.FEMALE?.message as any} hideError min={0} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="weightAnimalsContainers">
                                    <h5 className="weightAnimalsLabel">Peso adulto</h5>
                                    <div className="weightAnimalsInputs" style={{ justifyContent: "space-between" }}>
                                        <div>
                                            <Input style={{ width: 240 }} type="number" control={control} name={`parameter.ADULT_WEIGHT.MALE`} theme={"normal"} label="Macho" errorText={(errors?.parameter as any)?.ADULT_WEIGHT?.MALE?.message as any} hideError min={0} />
                                        </div>
                                        <div>
                                            <Input style={{ width: 240 }} type="number" control={control} name={`parameter.ADULT_WEIGHT.FEMALE`} theme={"normal"} label="Femea" errorText={(errors?.parameter as any)?.ADULT_WEIGHT?.FEMALE?.message as any} hideError min={0} />
                                        </div>
                                    </div>
                                </div>

                                <br />
                            </div>
                        </div>
                    </div>

                </main>

                <div className="delimiter" style={{ marginTop: 15 }} />

                <FooterEditOnboarding
                    undoFunction={() => setSystemManager(null)}
                    saveFunction={handleSubmit((data) => {
                        if (!submiting) {
                            saveMonthyEvolution(data)
                        }
                    })}
                    isNew={false}
                    disabledSubmit={submiting}
                />
            </form>
        </>
    )
}